var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-container",class:{ 'section-container--bordered': _vm.isBordered, 'section-container--full-width': _vm.isFullWidth }},[(_vm.hasHeader)?_c('div',{staticClass:"section-container__header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }